import React from 'react';
import { gql } from '@apollo/client';
import { Datagrid, TextField, DateField, BooleanField } from 'react-admin';
import List from 'components/List';
import IdField from 'components/IdField';
import LinkField from 'components/LinkField';
import { ProfessionalScreeningFilters } from './ProfessionalScreeningFilters';

const ProfessionalScreeningsList = () => {
  return (
    <List
      filters={ProfessionalScreeningFilters}
      exporter={false}
      data-testid="professional-screenings-list"
    >
      <Datagrid bulkActionButtons={false} rowClick="show">
        <IdField label="ID" />
        <LinkField label="Professional Id" source="professional_id" />
        <DateField
          label="Scheduled Time"
          source="scheduled_time"
          showTime
          options={{ hour12: false }}
        />
        <DateField label="Canceled At" source="canceled_at" showTime options={{ hour12: false }} />
        <BooleanField label="No Show" source="no_show" />
        <LinkField
          label="Screener"
          source="screener_account.name"
          to={(record) => `/Account/${record.screener_account_id}/show`}
          typename="Account"
        />
        <TextField label="Reason" source="reason" />
        <TextField label="Type" source="screening_type" />
        <TextField label="Calendly Event Uuid" source="calendly_event_uuid" />
        <TextField label="Calendly Invitee Uuid" source="calendly_invitee_uuid" />
      </Datagrid>
    </List>
  );
};

ProfessionalScreeningsList.query = gql`
  query GET_LIST($input: ProfessionalScreeningQueryInput) {
    _professionalScreeningsMeta(input: $input) {
      count
    }
    professionalScreenings(input: $input) {
      id
      professional_id
      screener_account_id
      screener_account {
        id
        name
      }
      scheduled_time
      calendly_event_uuid
      calendly_invitee_uuid
      reason
      screening_type
      canceled_at
      no_show
    }
  }
`;

export default ProfessionalScreeningsList;
